import { getAppUrl } from '@/config/marketing-nav.config'

const signupHref = getAppUrl('/signup')

export type FoundingBenefit = {
  tag: string
  description: string
}

export type FoundingTradeItem = {
  title: string
  description: string
}

export const foundingTradersContent = {
  eyebrow: 'Founding Traders',
  heroTitle: 'A working group, not a leaderboard',
  heroParagraphs: [
    'Most consumer products run “communities” with points or referral codes that decay into nothing. We have built an approach that will allow active users/traders to influence and see the product before it ships, tell us what is wrong with it, and decide with us what gets built next.',
    'The trade is simple. You give us your time and your judgment. We give you access, influence, and as the ultimate thank you a humanoid robot that speaks Ivy\'s language.',
    'Gated by seriousness, not account size.',
  ],
  heroCtaLabel: 'Request an Invitation',
  heroCtaHref: signupHref,
  benefitsTitle: 'What you get',
  benefits: [
    {
      tag: 'Beta',
      description:
        'Every new agent, scan, and integration reaches Founding Traders first.',
    },
    {
      tag: 'Direct',
      description:
        'A working channel to the people who build the product. Not a support queue.',
    },
    {
      tag: 'Credit',
      description:
        'Your name in the product. A small credit on a page most users will never read. You will know it is there.',
    },
    {
      tag: 'Pricing',
      description:
        'Founding Trader pricing, held. We will raise prices on the public tiers. We will not raise yours.',
    },
  ] satisfies FoundingBenefit[],
  tradeEyebrow: 'The Trade',
  tradeTitle: 'What we ask in return',
  tradeLead:
    'A working group only works if the people in it actually work. Three things, none of them optional.',
  tradeItems: [
    {
      title: 'Use the product seriously',
      description:
        'Not casually, not occasionally. The feedback we need only comes from real use - the kind that surfaces edge cases, friction, and the answers that almost-but-not-quite landed.',
    },
    {
      title: 'Tell us what is broken',
      description:
        'Without that, the working group is a fan club. We are not interested in running a fan club. The channel is open precisely so you can push back, and we expect you to use it.',
    },
    {
      title: 'Bring us trading buddies you respect',
      description:
        'Someone who would meet the same bar we are asking you to meet. Quality of the group is the whole point.',
    },
  ] satisfies FoundingTradeItem[],
  ctaTitle: 'The future of trading feels human again',
  ctaLead: 'Stop trading through disconnected tools and build your own financial Jarvis.',
  ctaPrimaryLabel: 'Get Started',
  ctaPrimaryHref: signupHref,
}
